var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMypageShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid/General/Shopping-bag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24806 7.13012V7.5H5.74693C5.29973 7.5 4.92018 7.82799 4.85535 8.27047L4.63667 9.76292C4.20965 12.6773 4.20965 15.6384 4.63667 18.5529C4.82801 19.8588 5.88106 20.8683 7.19385 21.0045L7.82272 21.0697C10.5988 21.3576 13.3973 21.3576 16.1734 21.0697L16.8023 21.0045C18.1151 20.8683 19.1681 19.8588 19.3594 18.5529C19.7865 15.6384 19.7865 12.6773 19.3594 9.76292L19.1408 8.27047C19.0759 7.82799 18.6964 7.5 18.2492 7.5H16.7481V7.13013C16.7481 4.96238 15.2805 3.06964 13.181 2.52979C12.405 2.33024 11.5911 2.33024 10.8151 2.52979C8.71567 3.06964 7.24806 4.96238 7.24806 7.13012ZM12.8074 3.98252C12.2765 3.84599 11.7196 3.84599 11.1887 3.98252C9.75222 4.3519 8.74806 5.64693 8.74806 7.13012V7.5H15.2481V7.13013C15.2481 5.64693 14.2439 4.3519 12.8074 3.98252ZM8.74806 9C8.74806 8.58579 8.41228 8.25 7.99806 8.25C7.58385 8.25 7.24806 8.58579 7.24806 9V11C7.24806 11.4142 7.58385 11.75 7.99806 11.75C8.41228 11.75 8.74806 11.4142 8.74806 11V9ZM16.7481 9C16.7481 8.58579 16.4123 8.25 15.9981 8.25C15.5838 8.25 15.2481 8.58579 15.2481 9V11C15.2481 11.4142 15.5838 11.75 15.9981 11.75C16.4123 11.75 16.7481 11.4142 16.7481 11V9Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypageShop);
export default __webpack_public_path__ + "static/media/mypage_shop.e4f63ebe253b5336482a2bd4c5c940b8.svg";
export { ForwardRef as ReactComponent };